"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@mui/styles");
var _Radio = _interopRequireDefault(require("@mui/material/Radio"));
var _RadioGroup = _interopRequireDefault(require("@mui/material/RadioGroup"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _uiTheme = _interopRequireDefault(require("@kyruus/ui-theme"));
var _components = require("./components");
const KyruusRadio = (0, _styles.withStyles)({
  root: {
    color: _uiTheme.default.color_providermatch_secondary,
    '&:hover': {
      backgroundColor: 'inherit'
    },
    '&$checked': {
      color: _uiTheme.default.color_providermatch
    }
  },
  checked: {}
})(props => /*#__PURE__*/_react.default.createElement(_Radio.default, (0, _extends2.default)({
  color: "default"
}, props)));
const KyruusFormControlLabel = (0, _styles.withStyles)({
  root: {
    '& span': {
      whiteSpace: 'pre-line'
    }
  }
})(props => /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, props));
const Radio = _ref => {
  let {
    name,
    row,
    labelPlacement,
    selected,
    onChange,
    options,
    disabled,
    className,
    mode,
    buttonStyle = 'primary',
    legend,
    RenderOption,
    RenderSelectedOption,
    focusTextColor,
    focusBackgroundColor,
    focusOutlineColor,
    focusOutlineWidth,
    focusOutlineStyle,
    focusOutlineOffset,
    ...props
  } = _ref;
  const handleChange = event => {
    onChange(event, event.target.value);
  };
  if (mode === 'buttons') {
    return /*#__PURE__*/_react.default.createElement(_components.RadioButtonGroup, {
      className: className,
      ariaDescribedby: props['aria-describedby'],
      legend: legend,
      options: options,
      value: selected,
      buttonStyle: buttonStyle,
      row: row,
      name: name,
      onChange: handleChange,
      RenderOption: RenderOption,
      RenderSelectedOption: RenderSelectedOption,
      focusTextColor: focusTextColor,
      focusBackgroundColor: focusBackgroundColor,
      focusOutlineColor: focusOutlineColor,
      focusOutlineWidth: focusOutlineWidth,
      focusOutlineStyle: focusOutlineStyle,
      focusOutlineOffset: focusOutlineOffset
    });
  }
  return /*#__PURE__*/_react.default.createElement(_RadioGroup.default, {
    className: className,
    "aria-label": props['aria-label'],
    "aria-describedby": props['aria-describedby'],
    "aria-invalid": props['aria-invalid'],
    name: name,
    value: selected,
    onChange: handleChange,
    row: row,
    "data-testid": "radio-group"
  }, (0, _map.default)(options).call(options, option => /*#__PURE__*/_react.default.createElement(KyruusFormControlLabel, {
    key: option.value,
    labelPlacement: labelPlacement,
    value: option.value,
    control: /*#__PURE__*/_react.default.createElement(KyruusRadio, {
      disabled: option.disabled || disabled
    }),
    label: option.label
  })));
};
Radio.propTypes = {
  /**
   * The name property to apply to the form group
   */
  name: _propTypes.default.string,
  /**
   * Whether to display the buttons in a row (when false buttons are displayed in a single column)
   */
  row: _propTypes.default.bool,
  /**
   * Where to place the button label (either 'end' or 'start')
   */
  labelPlacement: _propTypes.default.oneOf(['end', 'start']),
  /**
   * Which value is currently selected (required - this component cannot manage it's own state)
   */
  selected: _propTypes.default.string.isRequired,
  /**
   * Callback for handling changes to the selected radio button
   * args: (event, optionString)
   */
  onChange: _propTypes.default.func.isRequired,
  /**
   * Classname to be applied to outer RadioGroup (enables styling via emotion)
   */
  className: _propTypes.default.string,
  /**
   * Whether the radio buttons should be disabled
   */
  disabled: _propTypes.default.bool,
  /**
   * A list of options to create radio buttons for.
   * Example: [{value: 'f', label: 'Female'}, ...]
   */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    buttonStyle: _propTypes.default.oneOf(['primary', 'secondary']),
    ariaDescribedby: _propTypes.default.string,
    /** An element containing a descriptive text for screen readers */
    description: _propTypes.default.node,
    disabled: _propTypes.default.bool
  })).isRequired,
  'aria-describedby': _propTypes.default.string,
  'aria-invalid': _propTypes.default.bool,
  'aria-label': _propTypes.default.string,
  /**
   * Mode to operate in. 'buttons' is the only option and will render the radios so they look like buttons
   */
  mode: _propTypes.default.string,
  /**
   * Styles to apply when operating in buttons mode
   */
  buttonStyle: _propTypes.default.oneOf(['primary', 'secondary']),
  /**
   * The legend to render above the radios
   */
  legend: _propTypes.default.string,
  /**
   * A renderer for the body of the label that displays to the user when it is not selected
   */
  RenderOption: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * A renderer for the body of the label that displays to the user when it is selected
   */
  RenderSelectedOption: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * Text color for when the component is focused ~but unchecked~
   */
  focusTextColor: _propTypes.default.string,
  /**
   * Background color for when the component is focused ~but unchecked~
   * Applies when component is rendering <CustomRadioButton /> for its inputs
   */
  focusBackgroundColor: _propTypes.default.string,
  /**
   * Outline color for when the component is focused and checked or unchecked
   * Applies when component is rendering <CustomRadioButton /> for its inputs
   */
  focusOutlineColor: _propTypes.default.string,
  /**
   * Outline width for when the component is focused and checked or unchecked
   * Applies when component is rendering <CustomRadioButton /> for its inputs
   */
  focusOutlineWidth: _propTypes.default.string,
  /**
   * Outline style for when the component is focused and checked or unchecked
   * Applies when component is rendering <CustomRadioButton /> for its inputs
   */
  focusOutlineStyle: _propTypes.default.string,
  /**
   * Outline offset for when the component is focused and checked or unchecked
   * Applies when component is rendering <CustomRadioButton /> for its inputs
   */
  focusOutlineOffset: _propTypes.default.string
};
Radio.defaultProps = {
  name: '',
  disabled: false,
  className: '',
  row: false,
  labelPlacement: 'end',
  ariaLabel: '',
  buttonStyle: 'primary'
};
var _default = exports.default = Radio;
Radio.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Radio",
  "props": {
    "buttonStyle": {
      "defaultValue": {
        "value": "'primary'",
        "computed": false
      },
      "description": "Styles to apply when operating in buttons mode",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }]
      },
      "required": false
    },
    "name": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The name property to apply to the form group",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Whether the radio buttons should be disabled",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Classname to be applied to outer RadioGroup (enables styling via emotion)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "row": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Whether to display the buttons in a row (when false buttons are displayed in a single column)",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "labelPlacement": {
      "defaultValue": {
        "value": "'end'",
        "computed": false
      },
      "description": "Where to place the button label (either 'end' or 'start')",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'end'",
          "computed": false
        }, {
          "value": "'start'",
          "computed": false
        }]
      },
      "required": false
    },
    "ariaLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "required": false
    },
    "selected": {
      "description": "Which value is currently selected (required - this component cannot manage it's own state)",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "onChange": {
      "description": "Callback for handling changes to the selected radio button\nargs: (event, optionString)",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "options": {
      "description": "A list of options to create radio buttons for.\nExample: [{value: 'f', label: 'Female'}, ...]",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "value": {
              "name": "string",
              "required": true
            },
            "label": {
              "name": "string",
              "required": true
            },
            "buttonStyle": {
              "name": "enum",
              "value": [{
                "value": "'primary'",
                "computed": false
              }, {
                "value": "'secondary'",
                "computed": false
              }],
              "required": false
            },
            "ariaDescribedby": {
              "name": "string",
              "required": false
            },
            "description": {
              "name": "node",
              "description": "An element containing a descriptive text for screen readers",
              "required": false
            },
            "disabled": {
              "name": "bool",
              "required": false
            }
          }
        }
      },
      "required": true
    },
    "aria-describedby": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "aria-invalid": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "aria-label": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "mode": {
      "description": "Mode to operate in. 'buttons' is the only option and will render the radios so they look like buttons",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "legend": {
      "description": "The legend to render above the radios",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "RenderOption": {
      "description": "A renderer for the body of the label that displays to the user when it is not selected",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": false
    },
    "RenderSelectedOption": {
      "description": "A renderer for the body of the label that displays to the user when it is selected",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": false
    },
    "focusTextColor": {
      "description": "Text color for when the component is focused ~but unchecked~",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "focusBackgroundColor": {
      "description": "Background color for when the component is focused ~but unchecked~\nApplies when component is rendering <CustomRadioButton /> for its inputs",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "focusOutlineColor": {
      "description": "Outline color for when the component is focused and checked or unchecked\nApplies when component is rendering <CustomRadioButton /> for its inputs",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "focusOutlineWidth": {
      "description": "Outline width for when the component is focused and checked or unchecked\nApplies when component is rendering <CustomRadioButton /> for its inputs",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "focusOutlineStyle": {
      "description": "Outline style for when the component is focused and checked or unchecked\nApplies when component is rendering <CustomRadioButton /> for its inputs",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "focusOutlineOffset": {
      "description": "Outline offset for when the component is focused and checked or unchecked\nApplies when component is rendering <CustomRadioButton /> for its inputs",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};